<template>
	<div class="layout-footer">
		<span class="footer-text" style="margin-right: 5px">Footer</span>
<!--		<img src="assets/layout/images/logo.svg" alt="sigma" width="80"/>-->
	</div>
</template>

<script>
	export default {
		name: "AppFooter"
	}
</script>

<style scoped>
</style>